<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section three-quarters">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <nz-row [nzGutter]="[16, 16]">
      <nz-col [nzSpan]="24">
        <h1
          class="title"
          i18n="@@page-photo-downloader-content-title"
          nz-typography>
          Download photos from <u>Instagram</u> instantly
        </h1>
      </nz-col>
      <nz-col [nzSpan]="24">
        <app-download-form
          (stateEventEmitter)="onDownloadStateChanged($event)"
          [type]="DownloadType.PHOTO" />
      </nz-col>
      @if (processableStates.includes(downloadState)) {
        <nz-col [nzSpan]="24" class="fade-in">
          @switch (downloadState) {
            @case (DownloadState.CAPTCHA_ERROR) {
              <nz-alert
                i18n-nzMessage="
                  @@page-photo-downloader-content-captcha-error-alert-message"
                nzMessage="Wow, looks like you're a robot. If not, reload the page and try again"
                [nzBanner]="true"
                [nzType]="'warning'" />
            }
            @case (DownloadState.NOT_FOUND_ERROR) {
              <nz-alert
                i18n-nzMessage="
                  @@page-photo-downloader-content-not-found-error-alert-message"
                nzMessage="The photo wasn't found. Check that the link is correct and that the profile is public"
                [nzBanner]="true"
                [nzType]="'info'" />
            }
            @case (DownloadState.UNEXPECTED_ERROR) {
              <nz-alert
                i18n-nzMessage="
                  @@page-photo-downloader-content-unexpected-error-alert-message"
                nzMessage="Can't load the photo. Please try again or come back later"
                [nzBanner]="true"
                [nzType]="'error'" />
            }
            @case (DownloadState.OK) {
              <nz-alert
                i18n-nzMessage="
                  @@page-photo-downloader-content-ok-alert-message"
                nzMessage="The photo was successfully found. The download will start shortly"
                [nzBanner]="true"
                [nzType]="'success'" />
            }
          }
        </nz-col>
      }
      <nz-col
        [nzSpan]="24"
        class="ya-banner-300"
        id="yandex_rtb_R-A-15626278-3" />
    </nz-row>
  </nz-col>
</nz-row>
<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section half bg-dark-grey">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <app-greetings [greetingsDTO]="greetingsDTO" />
  </nz-col>
</nz-row>
<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section full bg-light-grey">
  <nz-col
    [nzLg]="{ span: 18, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <app-benefits [benefitsDTO]="benefitsDTO" />
  </nz-col>
</nz-row>
<nz-row
  [nzAlign]="'middle'"
  [nzJustify]="'center'"
  class="section full bg-dark-grey">
  <nz-col
    [nzLg]="{ span: 18, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <app-instruction [instructionDTO]="instructionDTO" />
  </nz-col>
</nz-row>
